import {useRef,type PointerEvent} from 'react'
export function SignaturePad({ onChange }: { onChange: (value: string | null) => void }) {
  const canvas = useRef<HTMLCanvasElement>(null)
  const drawing = useRef(false)
  const started = useRef(false)
  function point(event: PointerEvent<HTMLCanvasElement>) {
    const box = event.currentTarget.getBoundingClientRect()
    return { x: (event.clientX - box.left) * 600 / box.width, y: (event.clientY - box.top) * 180 / box.height }
  }
  function start(event: PointerEvent<HTMLCanvasElement>) {
    const element = canvas.current
    const context = element?.getContext('2d')
    if (!element || !context) return
    element.setPointerCapture(event.pointerId)
    drawing.current = true

    context.strokeStyle = '#0b3d70'
    context.lineWidth = 3
    context.lineCap = 'round'
    const { x, y } = point(event)
    context.beginPath(); context.moveTo(x, y)
  }
  function move(event: PointerEvent<HTMLCanvasElement>) {
    if (!drawing.current) return
    const context = canvas.current?.getContext('2d')
    if (!context) return
    const { x, y } = point(event)
    context.lineTo(x, y); context.stroke(); started.current=true
  }
  function end() {
    drawing.current = false
    if (started.current) onChange(canvas.current?.toDataURL('image/png').split(',')[1] ?? null)
  }
  function clear() {
    canvas.current?.getContext('2d')?.clearRect(0, 0, 600, 180)
    started.current = false
    onChange(null)
  }
  return <div className="portaria-signature"><canvas ref={canvas} width={600} height={180}
      aria-label="Assinatura de quem retirou a encomenda" onPointerDown={start}
      onPointerMove={move} onPointerUp={end} onPointerCancel={end} />
    <button type="button" className="portaria-quiet" onClick={clear}>Limpar assinatura</button>
  </div>
}
